exports = module.exports = require("../../../../../node_modules/_css-loader@0.25.0@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".m-alicare-unread {\n  display: none;\n  position: absolute;\n  bottom: 8px;\n  right: 0;\n  background-color: #fff;\n  height: 36px;\n  border-radius: 18px 0 0 18px;\n  border: 0;\n  width: 120px;\n  font-size: 14px;\n  color: #666; }\n  .m-alicare-unread svg {\n    width: 14px;\n    height: 22px;\n    -webkit-transform: rotate(180deg);\n    transform: rotate(180deg);\n    color: #FFC940; }\n  .m-alicare-unread svg,\n  .m-alicare-unread > span {\n    vertical-align: middle; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.25.0@css-loader?{}!./node_modules/_sass-loader@4.0.2@sass-loader?{"sourceMap":true}!./node_modules/_postcss-loader@1.3.3@postcss-loader?{"sourceMap":true}!./src/component/view/body/unread/index.scss
// module id = 162
// module chunks = 0 1